import { ErrorHandler, Injectable, Injector } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'

import { TraceService } from './trace.service'

/**
 * Manda a la bitácora los errores de JavaScript que hoy solo se ven en la consola.
 *
 * !! Llama a `super.handleError`. Sin eso desaparecería el diagnóstico que el equipo usa hoy: este
 * manejador AGREGA la bitácora, no reemplaza a la consola.
 */
@Injectable()
export class TraceErrorHandler extends ErrorHandler {
  //* Se pide el `Injector` y no el `TraceService` directo porque el ErrorHandler se construye antes
  //* que casi todo: exigir el servicio en el constructor arrastraría AuthService y HttpClient a esa
  //* fase temprana del arranque.
  constructor(private readonly injector: Injector) {
    super()
  }

  override handleError(error: unknown): void {
    try {
      //* Los errores HTTP ya los registró el interceptor, con su método, su ruta y su duración.
      //* Registrarlos otra vez aquí duplicaría cada fallo de red en la línea de tiempo.
      if (!(error instanceof HttpErrorResponse)) this.injector.get(TraceService).recordError(error)
    } catch {
      //* Si la bitácora no está lista, el error igual tiene que llegar a la consola.
    }
    super.handleError(error)
  }
}
